/**
 * access-level-select.tsx — Ô chọn mức quyền của nhân viên trên một kênh (Quản lý kênh | Tiếp nhận).
 * Dùng ở Đội ngũ → Phân quyền theo kênh, popup "Kênh phụ trách" và hộp "Thêm nhân viên". Chữ ở lib/channel-access.ts.
 */
import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { ACCESS_LEVELS, ACCESS_LEVEL_META, type AccessLevel } from '@/lib/channel-access'
import { cn } from '@/lib/utils'

export function AccessLevelSelect({
  value, onChange, disabled, className, ariaLabel,
}: { value: AccessLevel; onChange: (v: AccessLevel) => void; disabled?: boolean; className?: string; ariaLabel?: string }) {
  const { t } = useTranslation('sharedMisc')
  return (
    <Select value={value} onValueChange={(v) => onChange(v as AccessLevel)} disabled={disabled}>
      <SelectTrigger className={cn('h-8 w-[140px] text-xs', className)} aria-label={ariaLabel ?? t('accessLevelSelect.ariaLabel')} title={ACCESS_LEVEL_META[value].hint}>
        {/* Ô chỉ hiện nhãn ngắn — dòng mô tả chỉ nằm trong danh sách xổ xuống. */}
        <SelectValue>{ACCESS_LEVEL_META[value].label}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {ACCESS_LEVELS.map((l) => (
          <SelectItem key={l} value={l}>
            <span className="block text-sm">{ACCESS_LEVEL_META[l].label}</span>
            <span className="block max-w-[260px] whitespace-normal text-[11px] leading-snug text-muted-foreground">{ACCESS_LEVEL_META[l].hint}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

/** Giải thích hai mức — hiện dưới danh sách kênh để người dùng hiểu trước khi chọn. */
export function AccessLevelLegend({ className }: { className?: string }) {
  return (
    <dl className={cn('grid gap-2 rounded-lg bg-muted/40 p-3 text-xs sm:grid-cols-2', className)}>
      {ACCESS_LEVELS.map((l) => (
        <div key={l}>
          <dt className="font-medium">{ACCESS_LEVEL_META[l].label}</dt>
          <dd className="mt-0.5 text-muted-foreground">{ACCESS_LEVEL_META[l].hint}</dd>
        </div>
      ))}
    </dl>
  )
}
